module.exports = __webpack_public_path__ + "static/media/artFunder.ee4ffdae.png";